import { useState } from 'react';
import { Button, Checkbox, Col, Form, message, Modal, Row, Space, Spin, Typography } from 'antd';
import { CloseOutlined, DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';

import useEgresado from '../../../hooks/HookEgresado';
import dayjs from 'dayjs';

const options = [
  { value: 'Resumen Profesional', label: 'Resumen profesional' },
  { value: 'Competencias Técnicas', label: 'Habilidades Técnicas' },
  { value: 'Competencias Personales', label: 'Habilidades Blandas' },
  { value: 'Herramientas y Tecnologías', label: 'Herramientas de software' },
  { value: 'Experiencia Profesional', label: 'Experiencia profesional' },
  { value: 'Formación Académica', label: 'Experiencia académica' },
  { value: 'Idiomas', label: 'Idiomas' },
];

const CvGenerator = () => {
  const { alumno, getCvPdf, loading, validarDatosEgresado } = useEgresado();
  const [form] = Form.useForm();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [openModal, setOpenModal] = useState(false);


  const handleOpenModal = async () => { 
    const validarAlumno = await validarDatosEgresado();
    if (!validarAlumno) return;
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setPdfUrl(null);
  };

  const onGenerateCv = async () => {

    try {
      const values = await form.validateFields();
      const excluded_values = options.map(option => option.value).filter(value => !values.cvType.includes(value));
      return await getCvPdf({ 'excluded_values': excluded_values });
    } catch (error) {
      message.error('Por favor, completa todos los campos.');
    }
  }
  const handleGenerateCV = async () => {
    const cv = await onGenerateCv();
    cv?.success && setPdfUrl(cv.url);
  };


  const handleDownload = async () => {
    try {
      const cv = await onGenerateCv();
      if (!cv?.success) return;
      const link = document.createElement('a');
      link.href = cv.url;
      link.download = `CV_${alumno?.nombre_completo?.replace(/\s/g, '_')}_${dayjs().format('YYYY')}.pdf`;
      link.click();
    } catch (error) {
      message.error('Error al descargar el CV');
    }
  };


  return (
    <>
      <a href="#" onClick={handleOpenModal} >
        Generar CV
      </a>
      <Modal
        title={<Row align="middle" justify="center">Generador de CV</Row>}
        open={openModal}
        onCancel={handleCloseModal}
        destroyOnHidden
        height={"70%"}
        footer={[
          <Space key="cv_action_modal" align="center" justify="space-between">
            <Button key="back" icon={<CloseOutlined />} loading={loading} onClick={handleCloseModal}>
              Cerrar
            </Button>
            <Button key="download" type="primary" icon={<DownloadOutlined />} loading={loading} onClick={handleDownload}>
              Descargar
            </Button>
            <Button key="submit" type="primary" icon={<FilePdfOutlined />} loading={loading} onClick={handleGenerateCV}>
              Visualizar
            </Button>
          </Space>
        ]}
      >
        <Spin spinning={loading}>
          <FormCvGenerator form={form} />
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              width="100%"
              height="60%"
            />
          )}
        </Spin>
      </Modal>
    </>
  );
};

function FormCvGenerator({ form }) {
  return (
    <Row align="middle" justify="end">
      <Col>
        <Form
          form={form}
          onFinish={values => console.log('Success:', values)}
          onFinishFailed={errorInfo => console.log('Failed:', errorInfo)}
          wrapperCol={{ span: 10 }}
          vertical={'true'}
          initialValues={{
            cvType: options.map(option => option.value)
          }}
        >
          <Typography.Paragraph italic>
            *** Personaliza tu currículum. Puedes quitar secciones que no sean relevantes para ti desmarcándolas.
          </Typography.Paragraph>
          <Form.Item
            name="cvType"
            label=""
            rules={[
              {
                type: 'array', // Asegura que es un array de valores seleccionados
                min: 4, // Al menos 4 elementos seleccionados
                message: 'Por favor, selecciona al menos cuatro opciones'
              }
            ]}

          >
            <Checkbox.Group options={options} />
          </Form.Item>
        </Form >
      </Col>
    </Row>
  )
}

export default CvGenerator;
